import type { PropsWithChildren } from 'react';
import { Heading3 } from '../../Text';
import { Wrapper, Answer } from './EmbeddedFaqItem.styles';

type EmbeddedFaqItemProps = PropsWithChildren<{ question: string }>;

/**
 * Renders a single FAQ item embedded directly in article rich text, as
 * opposed to one rendered as part of the FAQ module's accordion. There is no
 * parent module here to toggle visibility, so question and answer are always
 * shown and there is no collapse affordance.
 */
const EmbeddedFaqItem = ({ question, children }: EmbeddedFaqItemProps) => (
  <Wrapper>
    <Heading3 textColor="current">{question}</Heading3>
    <Answer>{children}</Answer>
  </Wrapper>
);

export { EmbeddedFaqItem };
export type { EmbeddedFaqItemProps };
